<template>
    <div class="relative time-picker border-none text-black">
        <vue-timepicker
            format="hh:mm A"
            :minute-interval="15"
            v-model="timeVal"
            :placeholder="'Enter ' + type + ' time'"
            :disabled="clickable"
            close-on-complete
            apm-label="AM/PM"
            :drop-direction="displayTop ? 'up' : 'down'"
            :input-width="storefront ? '129px' : '10em'"
            @close="updateTime"
            hide-clear-button
            advanced-keyboard
        ></vue-timepicker>
    </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
export default {
    name: "TimePicker",
    props: ["day", "type", "times", "clickable", "storefront"],
    data() {
        return {
            timeVal: {
                hh: this.type === "start" ? "09" : "05",
                mm: "00",
                A: this.type === "start" ? "AM" : "PM",
            },
            firstLoad: true,
            displayTop: false,
        };
    },
    components: { VueTimepicker },
    watch: {
        times(time) {
            if (time) {
                this.parseTime(time);
            } else {
                this.setDefaults();
            }
        },
    },
    methods: {
        setDefaults() {
            this.timeVal.hh = this.type === "start" ? "09" : "05";
            this.timeVal.mm = "00";
            this.timeVal.A = this.type === "start" ? "AM" : "PM";
        },
        parseTime(timeString) {
            // Extract hours and minutes from the string
            const hours = parseInt(timeString.slice(0, 2), 10);
            const minutes = timeString.slice(2, 4);

            // Determine AM or PM
            const A = hours >= 12 ? "PM" : "AM";

            // Convert hours to 12-hour format
            const hh = (hours % 12 || 12).toString();

            // Pad the hours with a leading zero if necessary
            const formattedHours = hh < 10 ? "0" + hh : hh;

            // Assign the values to the timeObj
            this.timeVal.hh = formattedHours;
            this.timeVal.mm = minutes;
            this.timeVal.A = A;
        },
        updateTime() {
            this.$emit("update-time", {
                day: this.day,
                type: this.type,
                val: this.timeVal,
            });
        },
    },
    mounted() {
        if (this.day === "Sunday" || this.day === "Saturday") {
            this.displayTop = true;
        }
        if (this.times) {
            this.parseTime(this.times);
        } else {
            this.setDefaults();
        }
        this.$emit("update-time", {
            day: this.day,
            type: this.type,
            val: this.timeVal,
        });
    },
};
</script>
<style scoped></style>
